export const phoneFaxFormat = (e) => {
    (e.which > 57 || e.which < 48) && e.preventDefault()
    if (e.target.value.length === 3 || e.target.value.length === 7) {
      e.target.value = e.target.value.concat('-')
    }
    if (e.target.value.length === 12) {
      e.target.value = e.target.value.concat('x')
    }
  }
  
  export const faxFormat = (e) => {
    (e.which > 57 || e.which < 48) && e.preventDefault()
    if (e.target.value.length === 3 || e.target.value.length === 7) {
      e.target.value = e.target.value.concat('-')
    }
  }